import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SecurityService } from 'src/app/shared-services/services/security.service';
import { StartStoreInfoModel } from 'src/app/shared-services/models/stores.model';

@Component({
    selector: 'app-authenticated-layout',
    templateUrl: './authenticated-layout.component.html'
})
export class AuthenticatedLayoutComponent implements OnInit {

    public data: StartStoreInfoModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public securityService: SecurityService) {

    }

    ngOnInit() {
        if (this.securityService.startStoreInfo === undefined ||
            this.securityService.startStoreInfo === null) {

            this.securityService.getStart()
                .subscribe((data: StartStoreInfoModel) => {
                    this.securityService.startStoreInfo = data;
                    this.setStoreAddress();
                });
        } else {
            this.setStoreAddress();
        }
    }

    clickChangeStore(event: Event, countryCode: string) {
        this.securityService.currentCountryCode = countryCode;

        this.router.navigate(['/countries', countryCode, 'products']);
    }

    setStoreAddress() {
    }
}
